import { ReviewScoreItem } from "./types";

export const getViewOptions = () => [
  { label: "Week View", value: "week" },
  { label: "Month View", value: "month" },
  { label: "Year View", value: "year" },
];

export const getDateRangeByView = (
  view: string,
): { date_start: string; date_end: string } => {
  const now = new Date();
  const end = new Date(now);
  const start = new Date(now);

  switch (view.toLowerCase()) {
    case "week":
      start.setDate(end.getDate() - 7);
      break;
    case "month":
      start.setMonth(end.getMonth() - 1);
      break;
    case "year":
      start.setFullYear(end.getFullYear() - 1);
      break;
    default:
      start.setDate(end.getDate() - 7);
  }

  const format = (date: Date) => date.toISOString().split("T")[0];

  return {
    date_start: format(start),
    date_end: format(end),
  };
};

export const formatReviewScoreChartData = (data: ReviewScoreItem[]) => {
  return data.map((item) => ({
    name: item.date,
    reviewScore: item.average ?? 0,
  }));
};
